import jwt from 'jsonwebtoken';

/**
   * @description decoding token method
   * @param {string} token
   * @returns {object} payload
   */
  export const decode = (token) => {
    const payload = jwt.decode(token);
    // console.log(payload);
    return payload;
  };
